import * as t from 'io-ts';
import { meta } from '../..';

const data = t.type({ title: t.string });

export const recordCodec = t.type({
  id: t.string,
  data,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});
